import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import AccessContainer from '../../access/AccessContainer';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';
import { changeTracker } from '../../../redux/actions/TrackerActions';

class TrackerAccessComponent extends Component<Props> {
  render() {
    const {
      tracker: { tracker },
    } = this.props;
    const access: AccessBase = { permission: tracker.permission, collaborators: tracker.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Tracker')} />;
  }

  private changeAccess = (access: AccessBase) => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    tracker.permission = access.permission;
    tracker.collaborators = access.collaborators;
    changeTracker(tracker);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  tracker: state.tracker,
});

const mapDispatchToProps = { changeTracker };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(TrackerAccessComponent);
